const dataPlatformApiUri = process.env.aerialPlotConnections.aerialDataPlatformApi.baseUrl;
const aerialPlotApiUri = process.env.aerialPlotConnections.aerialPlotApi.baseUrl;

/**
 * Returns Promise<AerialPlotResponse> (JSON result object)
 */
export function createFlightsQuantifiedRegions(plotData, accessToken, fieldQuantifiedRegionIds = []) {
	return fetch(`${dataPlatformApiUri}createFlightsQuantifiedRegions`, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ plotData, fieldQuantifiedRegionIds }),
	}).then((response) => response.json());
}

/**
 * Returns Promise<AerialPlotResponse> (JSON result object)
 */
export function updateFlightsQuantifiedRegions(plotData, accessToken) {
	return fetch(`${dataPlatformApiUri}updateFlightsQuantifiedRegions`, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(plotData),
	}).then((response) => response.json());
}

export function checkIfFlightsQuantifiedRegionsExist(flightId, clientId, accessToken) {
	return fetch(
		`${aerialPlotApiUri}api/v1/QuantifiedRegions/CheckFlightsQuantifiedRegions?flightId=${flightId}&clientId=${clientId}`,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	).then((response) => response.json());
}
